<template>
  <div class="test-view cp3-new-7-dec similar-question">
    <div class="cp3-bucket-que-section remove-padding-top">
      <v-row>
        <v-col cols="16" sm="16">
            <div  class="filter-section-search">
          <div class="show-drop-down">
            <div class="field-data">
              <v-select
                :items="questionsFrom"
                label="Show Questions From"
                v-model="filters.quesFrom"
                class="fix-width-200"
              ></v-select>
            </div>
          </div>
             <div class="show-drop-down" v-if="filters.quesFrom !== 'bookmarks'">
            <div class="field-data">
              <v-select
                :items="chapters"
                label="Select Chapter"
                v-model="filters.chapter"
                class="fix-width-200"
              ></v-select>
            </div>
          </div>

           <div class="show-drop-down" v-if="filters.quesFrom === 'bookmarks'">
            <div class="field-data">
              <v-select
                :items="bookmarks"
                label="Select Bookmark Type"
                v-model="filters.bookmark"
                class="fix-width-200"
              ></v-select>
            </div>
          </div>

          <div class="show-drop-down" v-if="filters.quesFrom !== 'personal_qs' && filters.quesFrom !== 'bookmarks'">
            <div class="field-data">
              <v-select
                :items="topics"
                label="Topic"
                v-model="filters.topic"
                class="fix-width-200"
              ></v-select>
            </div>
          </div>
          
           <div class="show-drop-down" v-if="filters.quesFrom !== 'personal_qs' && filters.quesFrom !== 'bookmarks'">
            <div class="field-data">
              <v-select
                :items="difficultyLevels"
                label="Difficulty"
                v-model="filters.diffLevel"
                class="fix-width-200"
                item-title="title"
                item-value="id"
              ></v-select>
            </div>
          </div>
          <div class="show-drop-down" v-if="filters.quesFrom === 'module'">
            <div class="field-data">
              <v-select
                :items="modules"
                label="From Module"
                v-model="filters.module"
                class="fix-width-200"
              ></v-select>
            </div>
          </div>
          <div class="show-drop-down" v-if="filters.quesFrom === 'pyqs'">
            <div class="field-data">
              <v-select
                :items="pyqExams"
                label="Exam"
                v-model="filters.pyqExam"
                class="fix-width-200"
              ></v-select>
            </div>
          </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="question-scroll-container-search" :style="{ marginTop: isSecondRow ? '100px' : '50px' }" v-if="questions.length > 0">
      <div
        v-for="currentQuestion in questions"
        :key="currentQuestion.id"
        class="test-page-section cp3-bucket-que-section"
        ref="testView"
      >
        <div class="cp3-question-bucket">
          <v-card class="mx-auto normal-card live-test-hg" ref="testBlock" :style="{borderColor: getColorForCustomTest(currentQuestion)}">
            <pinch-zoom
              class="pinch-zoom"
              disableZoomControl="disable"
              :wheel="false"
            >
              <div class="tst-quection-block" ref="questionBox">
                <div v-if="questionTypes">
                  <div class="privew-test-bk">
                    <!-- <Comprehension
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.COMPREHENSION ||
                          currentQuestion.question_type == questionTypes.TC
                      "
                    /> -->

                    <ComprehensionMultiple :showAnswerField="true" :currentQuestion="currentQuestion" :isPreview="true"
                      v-if="
                        currentQuestion.question_type == questionTypes.COMPREHENSION ||
                        currentQuestion.question_type == questionTypes.TC
                      " />
                    
                    <SingleAnsQuePrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      :isPreview="isPreview"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SINGLE_CORRECT ||
                          currentQuestion.question_type ==
                            questionTypes.ASSERTION_REASON ||
                          currentQuestion.question_type ==
                            questionTypes.SINGLE_CORRECT_SEC2
                      "
                    />
                    <MultipleCorrectPrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MULTIPLE_CORRECT
                      "
                    />
                    <IntegerPrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type == questionTypes.INTEGER
                      "
                    />
                    <SubjectivePrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      :isPreview="data.isPreview"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SUBJECTIVE ||
                          currentQuestion.question_type ==
                            questionTypes.SUBJECTIVEINTEGER
                      "
                    />
                    <MatrixMatchPrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH
                      "
                    />

                    <MatrixMatchOptionPrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH_OPTION
                      "
                    />
                  </div>
                  <div class="pyq-tag">
                    <!-- <h5 class="pyq-title">
                      PYQ Tags
                    </h5> -->
                    <div class="jee-card-row">
                      <!-- <div v-for="tag in currentQuestion.tags" class="jee-btn">
                        {{ parseTagName(tag.tag) }}
                      </div> -->
                        
                    </div>
                  </div>
                </div>
              </div>
            </pinch-zoom>
            <div class="save-and-next-btn btn-last-report">
              <v-btn
                color="primary"
                @click="openReportErrorDialog(currentQuestion)"
                class="cust-btn margin-r"
              >
                Report Error
              </v-btn>
              <v-btn v-if="!currentQuestion.bookmarkQuestion && !currentQuestion.institute_id" color="primary" class="cust-btn margin-r"
                @click="addBookmark(currentQuestion)">Bookmark Question
              </v-btn>
              <v-btn v-if="currentQuestion.bookmarkQuestion && !currentQuestion.institute_id" color="#E9E8E7" class="cust-btn margin-r disabled-btn"
                @click="removeBookmarkDialog(currentQuestion)">Remove Bookmark
              </v-btn>
              <div class="btn-align">
                <div
                  class="pyq-tag"
                  v-if="!CUSTOM_INSTITUTE_ID.includes(myInstitute.id) && currentQuestion.tags && currentQuestion.tags.length"
                >
                  <div class="jee-card-row">
                      <v-tooltip
                          v-if="
                            currentQuestion.tags &&
                            currentQuestion.tags.some((tag) =>
                              tag.tag.includes('PYQ_')
                            ) &&
                            !showTags
                          "
                          bottom
                          :close-delay="100"
                          content-class="cust-new-tooltip-bottom search-another-drop-easy open-top"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="pyq-title active"
                              v-on="on"
                              v-bind="attrs"
                            >
                              PYQ
                            </v-btn>
                          </template>

                            <div
                              v-for="tag in currentQuestion.tags.filter((tag) =>
                                tag.tag.includes('PYQ_')
                              )"
                              :key="tag.id || tag.tag"
                              class="pyq-card"
                            >
                              <div class="pyq-btn">
                                {{ parseTagName(tag.tag) }}
                              </div>
                          </div>
                        </v-tooltip>
                  </div>
                  
                </div>
                  <div
                  class="pyq-tag"
                  v-if="!CUSTOM_INSTITUTE_ID.includes(myInstitute.id) && currentQuestion.modules && currentQuestion.modules.length"
                >
                  <div class="jee-card-row">
                  <v-tooltip
                          v-if="
                            currentQuestion.modules &&
                            currentQuestion.modules.some((tag) =>
                              tag.tag.includes('MODULE_')
                            )
                          "
                          bottom
                          :close-delay="100"
                          content-class="cust-new-tooltip-bottom search-another-drop-easy open-top"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="pyq-title active"
                              v-on="on"
                              v-bind="attrs"
                            >
                              MODULE
                            </v-btn>
                          </template>

                          <div>
                           <div
  v-for="tag in currentQuestion.modules.filter(tag => tag.tag.includes('MODULE_')
  )"
  :key="tag.id || tag.tag"
  class="pyq-card"
>
  <div class="pyq-btn">
    {{ parseTagName(tag.tag) }}
  </div>
</div>

                          </div>
                        </v-tooltip>
                  </div></div>
                 
                <v-btn v-if="!CUSTOM_INSTITUTE_ID.includes(myInstitute.id)"
                  class="current-question-info last-created-btn"
                  :class="
                    currentQuestion && currentQuestion.last_created_at
                      ? ''
                      : 'remove-pointer'
                  "
                  @mouseenter="getQuestionInfo(currentQuestion)"
                >
                  <v-tooltip
                    bottom
                    v-if="
                      currentQuestion &&
                        currentQuestion.last_created_at &&
                        currentQuestion.previewData
                    "
                    content-class="cust-new-tooltip-bottom search-another-drop-easy open-top"
                  >
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                        depressed
                        :class="{
                          'text-transform-none': true,
                          'btn-center': true,
                          'btn-default': true,
                        }"
                      >
                        <span class="last-info">Last Used </span>
                        <br />
                        <strong>
                          {{
                            currentQuestion.last_created_at
                              ? currentQuestion.last_created_at
                              : "NEVER"
                          }}
                        </strong>
                      </span>
                    </template>
                    <span>
                      <div class="history-data-parent">
                        <div class="r-body ">
                          <div class="history-data">
                            <span class="center-width"
                              ><strong>Date </strong></span
                            >
                            <span>{{ currentQuestion.last_created_at }}</span>
                          </div>
                          <div
                            class="history-data"
                            v-if="
                              currentQuestion &&
                                currentQuestion.lastScheduledCenters
                            "
                          >
                            <span class="center-width"
                              ><strong>Centers </strong></span
                            >
                            <span>{{
                              currentQuestion.lastScheduledCenters
                            }}</span>
                          </div>
                          <div
                            class="history-data"
                            v-if="
                              currentQuestion &&
                                currentQuestion.lastScheduledBatches
                            "
                          >
                            <span class="center-width"
                              ><strong>Batches </strong></span
                            >
                            <span>{{
                              currentQuestion.lastScheduledBatches
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </span>
                  </v-tooltip>

                  <span v-else class="last-info"
                    >Last Used <br />
                    <strong>
                      {{
                        currentQuestion.last_created_at
                          ? currentQuestion.last_created_at
                          : "NEVER"
                      }}
                    </strong></span
                  >
                </v-btn>
                <v-btn
                  color="primary"
                  :disabled="isEditable"
                  @click="addQuestionToBucket(currentQuestion)"
                  class="cust-btn right-align"
                >
                  Select this Q.
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
      <div v-intersect="infiniteScrolling"></div>
    </div>
    <div class="question-scroll-container-search  no-internet" :style="{ marginTop: isSecondRow ? '100px' : '50px' }" v-else>
      <h4>
        No Questions Found
      </h4>
    </div>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right"></div>
    </div>
   <AlertBox
      :width="modalWidth"
      :onClose="onCloseReport"
      component="components/student/Tests/PastTests/ReportError"
      :status="open"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import isMobile from "is-mobile";
import moment from "moment";
import momentDuration from "moment-duration-format";
momentDuration(moment);

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import QuestionPallet from "@/components/PreviewTest/QuestionPallet.vue";
import MiniQuestionPallet from "@/components/PreviewTest/MiniQuestionPallet.vue";
import LegendsPreview from "@/components/PreviewTest/LegendsPreview.vue";
import LegendsOnHover from "@/components/PreviewTest/LegendsOnHover.vue";
import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";

// importing components for edit mode
import SingleAnsQue from "@/components/QuestionType/SingleAnsQue.vue";
import MultipleCorrect from "@/components/QuestionType/MultipleCorrect.vue";
import Subjective from "@/components/QuestionType/Subjective.vue";
import Integer from "@/components/QuestionType/Integer.vue";
import MatrixMatchOption from "@/components/QuestionType/MatrixMatchOption.vue";
import MatrixMatch from "@/components/QuestionType/MatrixMatch.vue";
import Comprehensions from "@/components/QuestionType/Comprehensions.vue";
import ComprehensionMultiple from "@/components/PreviewTest/ComprehensionMultiple.vue";
import TC from "@/components/QuestionType/TC.vue";
// importing axios to cancel heartbeat request if it is pending state till the next heartbeat is called
import axios from "axios";
import constants from "@/utils/constants.js";
export default {
  name: "QuestionBucket",
  props: ["onClose", "status", "data", "onCustomizeClick"],
  components: {
    QuestionPallet,
    MiniQuestionPallet,
    LegendsPreview,
    LegendsOnHover,
    Comprehension,
    SingleAnsQuePrivew,
    MultipleCorrectPrivew,
    IntegerPrivew,
    SubjectivePrivew,
    AssertionReasonPrivew,
    MatrixMatchOptionPrivew,
    MatrixMatchPrivew,

    SingleAnsQue,
    MultipleCorrect,
    Subjective,
    Integer,
    MatrixMatchOption,
    MatrixMatch,
    Comprehensions,
    TC,
    dummyOptionsPQR: [],
    dummyOptions: [],
    dummyOptionsABC: [],
    Carousel,
    Slide,
    ComprehensionMultiple
  },
  async mounted() {
    console.log('MOUNTED DTAAAAA')
    this.callApi = false;
    this.isFilterUpdateInProgress = true;
    this.filters.chapter = this.data.question.dataType.id;
    this.filters.topic = this.data.question.topic_id ?  this.data.question.topic_id : this.data.question?.topic?.id;
     this.pyqExams = [
      {text: 'EAMCET', value: 'EAMCET'},
        {text: 'JEE ADVANCED', value: 'JEE ADVANCED'},
          {text: 'JEE MAIN', value: 'JEE MAIN'},
            {text: 'KCET', value: 'KCET'},
              {text: 'MHCET', value: 'MHCET'},
                 {text: 'NEET', value: 'NEET'}
    ]
    this.bookmarks=[
      {text: 'All Bookmarks', value: 'all_bookmarks'},
        {text: 'My Bookmarks', value: 'my_bookmarks'},
    ];


    this.dummyOptions = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: "",
        correct_answer: true,
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[2],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[3],
        option_text: "",
        correct_answer: false,
      },
    ];
    this.dummyOptionsABC = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: "",
        column: 1,
        correct_answer: "P",
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: "",
        column: 1,
        correct_answer: "P",
      },
    ];
    this.dummyOptionsPQR = [
      {
        index: this.OPTIONS_PQR[0],
        option_text: "",
        column: 2,
        correct_answer: "",
      },
      {
        index: this.OPTIONS_PQR[1],
        option_text: "",
        column: 2,
        correct_answer: "",
      },
    ];
    this.questionTypes = this.QUE_TYPES;
    this.questionStatus = this.QUESTION_STATUS;
    this.questionStatusColor = this.QUESTION_STATUS_COLOR;
    this.difficultyLevels = [...constants.DIFFICULTY_LEVELS, { id: 0, text: 'All' }];
    this.getQuestionBucket();
    // this.setIsPastTest(false);
    // await this.setCustomData();
    // this.reverseQuestionsType();
    // this.requestGetTestDetails();
    // this.renderMath();
    this.questionsFrom = ["Institute Qs.", "Module", "Bookmarks", "PYQs", "Master DB"].map(qf => {
      if (qf === 'Master DB') return { text: qf, value: 'master_db' };
       if (qf === 'Institute Qs.') return { text: qf, value: 'personal_qs' };
      return { text: qf, value: qf.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().replace(/\s+/g, '_') };
    });
    this.isSecondRow = false;
    this.loadChapters(this.data.question.dataType.parentDetails.id);
    this.loadPyqNMods();
    this.filters.diffLevel = 0;
  },
  data() {
    return {
      isPastTest: false,
      is_preview: true,
      modalWidth: null,
      showAnswerField: true,
      cComponent: "components/coordinator/Questionadd",
      alertBoxData: {},
      open: false,
      testDetails: null,
      questionTypes: this.QUE_TYPES,
      questionStatus: this.QUESTION_STATUS,
      questionStatusColor: this.QUESTION_STATUS_COLOR,
      questions: [],
      isEditable: this.data.isEditable,
      callApi: false,
      isPreview: "",
      currentPage: 1,
      totalPages: 10,
      pageSize: 5,
      allowScroll: false,
      rowCount: 2,
      scrollableElement: null,
      topics: [],
      chapters: [],
      modules: [],
      pyqExams: [],
      questionsFrom: [],
      difficultyLevels: [],
      filters: { quesFrom: "", chapter: "", diffLevel: 0, module: "", pyqExam: "", topic: "", bookmark: '' },
      isFilterUpdateInProgress: false,
      isSecondRow :false
    };
  },

  watch: {
   
    data(oldVal, newVal) {
      if (oldVal.question.id !== newVal.question.id || oldVal.isCallBucketApi) {
      
        this.resetData();
        this.questions = [];
        this.currentPage = 1;
        this.allowScroll = false;
        //this.getQuestionBucket();
        this.isEditable = this.data.isEditable;
      }else{
      this.filters.chapter = newVal.question.dataType.id;
      this.filters.topic = newVal.question.topic_id ?  newVal.question.topic_id : newVal.question?.topic?.id;
      }
    },
    status(val) {
      if (val == false) {
        this.filters= { quesFrom: "", chapter: "", diffLevel: 0, module: "", pyqExam: "", topic: "", bookmark:"" };
        let count = 0;
        this.questions.map((q) => {
          if (q.is_bucket_question) {
            count = count + 1;
          }
        });
        // this.onClose({ status: val, count: count, callApi:this.callApi });
      } else {
        this.callApi = false;
      }
    },
    "filters.chapter"(val, oldVal) {
      if (oldVal && val !== oldVal) {
        this.filters.topic = null;
      }
      this.loadTopics(val);
     // if (this.filters.quesFrom === 'bookmarks') return;
      this.handleFilterChange();
    },
    "filters.topic"(val) {
      //if (this.filters.quesFrom === 'bookmarks') return;
      this.handleFilterChange();
    },
    "filters.diffLevel"(val) {
      this.handleFilterChange();
    },
    "filters.pyqExam"(val) {
      if (this.filters.quesFrom !== 'pyqs') return;
      this.handleFilterChange();
    },
    "filters.module"(val) {
      if (this.filters.quesFrom !== 'module') return;
      this.handleFilterChange();
    },
    "filters.quesFrom"(val) {
      this.handleFilterChange();
    },
     "filters.bookmark"(val) {
      this.handleFilterChange();
    },
    "data.question"(val) {
      if (!val) return;

      this.loadChapters(val.dataType.parentDetails.id);
    },
  },
  computed: {
    ...mapState("userStore", ["myInstitute", "user"]),
  },
  
  beforeDestroy() {
    if (this.scrollableElement) {
      this.scrollableElement.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    ...mapActions({
      getSimilarQuestions: "testStore/getSimilarQuestions",
      getInstituteSimilarQuestions: "testStore/getInstituteSimilarQuestions",
      replaceQuestion: "testStore/replaceQuestion",
      replaceInstituteQuestion: "testStore/replaceInstituteQuestion",
      removeBucketQuestion: "testStore/removeBucketQuestion",
      getQuesDateAndViewCountOfLastCreQues:
        "testStore/getQuesDateAndViewCountOfLastCreQues",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      getPyqAndModuleTags: "utilStore/getPyqAndModuleTags",
      addBookmarkQuestion: "testStore/addBookmarkQuestion",
      removeBookmarkQuestion: "testStore/removeBookmarkQuestion",
    }),

    resetData() {

    this.isFilterUpdateInProgress = true;
    this.filters.chapter = this.data.question.dataType.id;
    this.filters.topic = this.data.question.topic_id ?  this.data.question.topic_id : this.data.question?.topic?.id;
    this.callApi = false;
     this.pyqExams = [
      {text: 'EAMCET', value: 'EAMCET'},
        {text: 'JEE ADVANCED', value: 'JEE ADVANCED'},
          {text: 'JEE MAIN', value: 'JEE MAIN'},
            {text: 'KCET', value: 'KCET'},
              {text: 'MHCET', value: 'MHCET'},
                 {text: 'NEET', value: 'NEET'}
    ]
    this.bookmarks=[
      {text: 'All Bookmarks', value: 'all_bookmarks'},
        {text: 'My Bookmarks', value: 'my_bookmarks'},
    ];


    this.dummyOptions = [
      { index: this.OPTIONS_ABC[0], option_text: "", correct_answer: true },
      { index: this.OPTIONS_ABC[1], option_text: "", correct_answer: false },
      { index: this.OPTIONS_ABC[2], option_text: "", correct_answer: false },
      { index: this.OPTIONS_ABC[3], option_text: "", correct_answer: false },
    ];

    this.dummyOptionsABC = [
      { index: this.OPTIONS_ABC[0], option_text: "", column: 1, correct_answer: "P" },
      { index: this.OPTIONS_ABC[1], option_text: "", column: 1, correct_answer: "P" },
    ];

    this.dummyOptionsPQR = [
      { index: this.OPTIONS_PQR[0], option_text: "", column: 2, correct_answer: "" },
      { index: this.OPTIONS_PQR[1], option_text: "", column: 2, correct_answer: "" },
    ];

    this.questionTypes = this.QUE_TYPES;
    this.questionStatus = this.QUESTION_STATUS;
    this.questionStatusColor = this.QUESTION_STATUS_COLOR;
    this.difficultyLevels = [...constants.DIFFICULTY_LEVELS, { id: 0, text: 'All' }];
    this.questionsFrom = ["Institute Qs.", "Module", "Bookmarks", "PYQs", "Master DB"].map(qf => {
      if (qf === 'Master DB') return { text: qf, value: 'master_db' };
       if (qf === 'Institute Qs.') return { text: qf, value: 'personal_qs' };
      return { text: qf, value: qf.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().replace(/\s+/g, '_') };
    });
    this.filters.diffLevel = 0;
    this.isSecondRow = false;
    this.getQuestionBucket();
    this.loadChapters(this.data.question.dataType.parentDetails.id);
    this.loadPyqNMods();
  },
    loadChapters(subjectId) {
      this.getDataTreeWithLevel({ level: 3, parent: [subjectId] })
        .then(response => {
          this.chapters = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.id;

            return c;
          });
        })
        .catch(err => console.log('Error getting level data: ', err));
    },
    loadTopics(chapterId) {
      this.getDataTreeWithLevel({ level: 4, parent: [chapterId] })
        .then(response => {
          this.topics = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.id;

            return c;
          });
          

        })
        .catch(err => console.log('Error getting level data: ', err));
    },
    loadPyqNMods() {
      this.getPyqAndModuleTags()
        .then(response => {
          if (!response) return;

           this.modules = response.modules.sort((a, b) => {
           return a.text.localeCompare(b.text);
            });
            console.log("deailssss", this.modules)
          //this.pyqExams = response.pyqs;
        })
        .catch(err => console.log('Error getting level data: ', err));
    },
    handleFilterChange() {
      if (this.isFilterUpdateInProgress) return;
      this.currentPage = 1;
      this.questions = [];
      this.getQuestionBucket();
    },
    onCloseReport(data) {
      this.open = data.status;
      if (data.action === "yes" && data.refId === "removeBookmark") {
        this.removeBookmark(data.item);
      }
    },
    handleScroll(event, q) {
      if (q.previewData) {
        q.previewData = false;
        this.$forceUpdate();
      }
    },
    getQuestionBucket() {
      if(this.$root.showLoader) return;
     // if (!this.filters.topic && this.filters.quesFrom !== 'personal_qs') return;
     if(this.filters.quesFrom !== 'bookmarks'){
     if (!this.filters.chapter && this.filters.quesFrom !== ('personal_qs')) return;
     }
      this.$root.showLoader = true;
      let reqData = {
        test_detail_id: this.data.question.test_detail_id,
        target_exam: this.data.question.target_exam,
        required_question_details: true,
        question_type: this.data.question.question_type,
        test_id: this.data.question.test_id,
        subject_id: this.data.question.dataType.parentDetails.id,
        required_question_details: true,
        selectedQuestionIds: [this.data.question.id],
        institute_id: this.myInstitute.id,
        user_id: this.user
          ? this.user.id.toString()
          : localStorage.getItem("guest_user_id"),
        creator_id: this.user
          ? this.user.id.toString()
          : localStorage.getItem("guest_user_id"),
        required_single_child_question_details:
          this.data.question.question_type ===
            this.questionTypes.COMPREHENSION ||
          this.data.question.question_type === this.questionTypes.TC,
        pagination: {
          page: this.currentPage,
          pageSize: this.pageSize,
        },

        // subtopic_id: this.data.question.subtopic_id,
        // concept_id: this.data.question.concept_id,
        // answer_type: this.data.question.answer_type
      };


      if (this.filters.chapter) {
        reqData.chapter_ids = [this.filters.chapter];
      }

      if (this.filters.quesFrom === 'personal_qs') {
        reqData.topic_ids = this.topics.map(tp => tp.value);
      } else if (this.filters.topic) {
        reqData.topic_id = this.filters.topic;
        reqData.topic_ids = [this.filters.topic];
      }

      if (this.filters.diffLevel) {
        reqData.difficulty_level = this.filters.diffLevel;
      } else {
        reqData.difficulty_level = 0;
      }

      if (this.filters.quesFrom === 'personal_qs') {
        reqData.personal_qs = true;
      }

      if(this.filters.quesFrom === 'master_db'){
         reqData.master_db = true;
      }

      if (this.filters.quesFrom === 'bookmarks') {
        reqData.bookmarks = true;
        reqData.bookmarkType = this.filters.bookmark ? this.filters.bookmark : null;
        reqData.chapter_ids = [];
        reqData.topic_id = null;
        reqData.topic_ids = [];
        //this.filters.chapter = '';
        //this.filters.topic = '';
      }

      if (this.filters.quesFrom === "module" && this.filters.module) {
        reqData.tags = [this.filters.module];
        reqData.isModules = true;
      } else if (this.filters.quesFrom === "module") {
        reqData.tags = ['ALL_MODULES'];
      }

      if (this.filters.quesFrom === "pyqs" && this.filters.pyqExam) {
        reqData.tags = [this.filters.pyqExam];
        reqData.isPyqs = true;
      } else if (this.filters.quesFrom === "pyqs") {
        reqData.tags = ['ALL_PYQS'];
      }

      if (this.data.question.subtype) {
        reqData.subType = this.data.question.subtype;
      }
      let fn = "getInstituteSimilarQuestions";
      if (this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
        fn = "getSimilarQuestions";
      }

       if(this.filters.quesFrom === 'pyqs' || this.filters.quesFrom === 'module' ){
         this.isSecondRow = true;
      }else{
         this.isSecondRow = false;
      }
      this[fn](reqData)
        .then((response) => {
          this.allowScroll = true;
          this.totalPages = response.pagination.pageCount;
          this.currentPage = response.pagination.page;
          this.rowCount = response.pagination.rowCount;
          this.isFilterUpdateInProgress = false;

          this.testDetails = response;
          // if(response && response.list && response.list.length>0 && response?.list?.[0]?.topic_id){
          // this.filters.topic = response?.list?.[0]?.topic_id;
          // }
          this.separateQuestions(response.list);
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.isFilterUpdateInProgress = false;
          console.log(err);
          this.$root.showLoader = false;
          if(err.data.errors.length > 0 && err.data.errors[0].code === "ERR0202"){
            this.onClose({ status: false, error: err, refId: "getQuestionBucket" });
          }
        });
    },
    openReportErrorDialog(currentQuestion) {
      this.alertBoxData = {
        question: currentQuestion,
        errorDescription: "",
      };
      this.modalWidth = "1000px";
      this.open = true;
      this.cComponent = "components/student/Tests/PastTests/ReportError";
      this.$forceUpdate();
    },
    addQuestionToBucket(question) {
      this.open = false;
      
      const reqData = {
        question_id: question.id,
        test_detail_id: this.data.question.test_detail_id,
        question_type: question.question_type,
        test_id: this.data.question.test_id,
      };
      let fn = "replaceInstituteQuestion";
      if (this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
        fn = "replaceQuestion";
      }
      if (
        question.question_type === this.questionTypes.COMPREHENSION ||
        question.question_type === this.questionTypes.TC
      ) {
        console.log("asdsdad", question)
         reqData.question_id = question?.parent_id ? question?.parent_id : question.id ;
      }
      this[fn](reqData)
        .then((response) => {
          // console.log(response);
          this.callApi = true;
          this.changeAddButtonStatus(question);
          // this.getQuestionBucket();
          // this.onClose({ reload: true, status: true });
        })
        .catch((err) => {
          console.log(err);
          // this.onClose({ reload: true, status: true });
        });
    },
    removeQuestionFromBucket(question) {
      this.open = false;

      const reqData = {
        question_id: question.id,
        test_detail_id: this.data.question.test_detail_id,
      };
      this.removeBucketQuestion(reqData)
        .then((response) => {
          // this.getQuestionBucket();
          this.callApi = true;
          this.changeAddButtonStatus(question);

          // this.onClose({ reload: true, status: true });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async separateQuestions(question) {
      let questions = question;
      // questions.sort(this.compare);
      let fql = {}; // filteredQuestionsList
      let subjectQuestionTypeList = {}; // for showing subject - section list
      //this.$root.showLoader = true;

      for (let i = 0; i < questions.length; i++) {
        let questionTypeId = 0;
        let questionTypeName = "";
        let q = null; // question
        let currentQuestionType = null; // current question in particular subject
        let subjectName = null; // current subject
        let subjectId = null; // current subject
        let subjectQuestionTypeObj = {};
        let questionId = 0;

        q = questions[i];
        questionId = q.id;
        questionTypeId = q.questiontype ? q.questiontype.id : q.question_type;
        questionTypeName = q.questiontype ? q.questiontype.value : "";
      }
      await this.generateQuestionsList(question);
    },
    //     setCurrentQuestionData(typeIndex, questionIndex) {
    //       this.setSelectedSQTIndex(typeIndex);
    //     },
    async generateQuestionsList(question) {
      let ql = question;
      let currentQuestion = {};
      let questionsList = this.questions;

      for (let i = 0; i < ql.length; i++) {
        const q = ql[i]; // current question in loop
        let questionTypeId = q.question_type;
        questionTypeId =
          questionTypeId == this.questionTypes.COMPREHENSION ||
          questionTypeId == this.questionTypes.TC
            ? q.subtype.id
              ? q.subtype.id
              : q.subtype
            : q.question_type;
        let currentQuestion = {};
        currentQuestion = this.generateQuestionObject(questionTypeId, q);
        currentQuestion.subtype = q.subtype
          ? q.subtype.id
            ? q.subtype.id
            : q.subtype
          : "";
        if (
          q.question_type == this.questionTypes.COMPREHENSION ||
          q.question_type == this.questionTypes.TC
        ) {
          currentQuestion.passage = q.passage;
        }
        currentQuestion = this.getCurrentQuestionCommonKeys(
          currentQuestion,
          q,
          i
        );
        questionsList.push(currentQuestion);
      }
      console.log("ASdasdsasd",questionsList)
      this.questions = questionsList;
    },
    getCurrentQuestionCommonKeys(currentQuestion, q, index) {
      currentQuestion.id = q.id;
      currentQuestion.is_bucket_question = q.is_bucket_question;
      currentQuestion.question_text = q.question_text;
      currentQuestion.question_type = q.question_type;
      currentQuestion.questionType = { id: q.question_type };
      currentQuestion.parent_id = q.parent_id;
      currentQuestion.section_id = q.section_id;
      currentQuestion.test_detail_id = q.test_detail_id;
      currentQuestion.correct_marks = q.marks;
      currentQuestion.negative_marks = q.negative_marks;
      currentQuestion.partial_marking = q.partial_marking;
      currentQuestion.solution = q.solution;
      currentQuestion.hints = q.hints;
      currentQuestion.userSelectedAnswer = q.user_selected_answer;
      currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
      currentQuestion.isAnswered = false; // to know if the current question is answered.
      currentQuestion.disabled = false; // disabled in case of preview test
      currentQuestion.isPreview = this.data.isPreview; // disabled in case of preview test
      currentQuestion.institute_id = q.institute_id;
      currentQuestion.question_view_count = q.question_view_count;
      currentQuestion.tags = q.tags;
      currentQuestion.modules = q.tags;
      currentQuestion.childQuestions = q?.sub_questions
      currentQuestion.isPreview = true


      
      currentQuestion.last_created_at = q.last_created_at
        ? moment(q.last_created_at).format(constants.DATE_FORMATS.DISPLAY_DATE)
        : null;
      currentQuestion.previewData = true;
      currentQuestion.bookmarkQuestion = q.question_bookmark ? true : false;  

      if (this.data.isPreview) {
        currentQuestion.status = this.questionStatus.ANSWER_SELECTED_SAVED; // "status" along with "isAnswered" will be used for loading legends & pallet info
        currentQuestion.isAnswered = this.data.isPreview; // to know if the current question is answered.
        currentQuestion.disabled = this.data.isPreview; // disabled in case of preview test
      }
      if (q.user_selected_answer && !this.data.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        currentQuestion.isAnswered = answer.answer ? true : false;
        currentQuestion.status = answer.status;
      }
     if (currentQuestion.subtype == this.questionTypes.COMPREHENSION_2Q_NU) {

   const updatedChildrens = (q?.sub_questions || []).map((item) => {
     if (item.correct_answer && item.parent_id !== null) {
     const [startValue, endValue] = item.correct_answer.split("##");
     return {
      ...item,
      startValue,
      endValue,
      disabled: true
      };
     } else {
      return { ...item , isMainQuestion: true};
     }
      });

      currentQuestion.childQuestions = updatedChildrens;
     }

      return currentQuestion;
    },
    checkIfAnswered(type, q) {
      let option = null;
      if (q.user_selected_answer && !this.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        q.status = answer.status;
        let options = q.options.map((o) => {
          return { ...o, ...{ correct_answer: false } };
        });
        if (answer.answer) {
          let switchType = 1;
          if (
            this.questionTypes.ASSERTION_REASON == type ||
            this.questionTypes.SINGLE_CORRECT == type ||
            this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
            this.questionTypes.COMPREHENSION_2Q_SA == type ||
            this.questionTypes.COMPREHENSION_2Q_MM == type ||
            this.questionTypes.COMPREHENSION_3Q_SA == type ||
            this.questionTypes.TC_2Q_SA == type ||
            this.questionTypes.TC_3Q_SA == type
          ) {
            switchType = 1;
          } else {
            switchType = 2;
          }
          switch (switchType) {
            case 1:
              option = options.find((o) => o.id == answer.answer.option_id);
              if (option) option.correct_answer = true;
              break;

            case 2:
              answer.answer.option_id.map((a) => {
                option = options.find((o) => o.id == a);
                if (option) option.correct_answer = true;
              });
              break;
          }
        }
        return options;
      } else return q.options;
    },
    generateQuestionObject(typeId, q) {
      let type = "";
      type = this.getQuestionType(typeId);
      let currentQuestion = {};
      currentQuestion.chapterId = q.data_type_id;
      currentQuestion.chapterName = q.datatype ? q.datatype.title : "";
      currentQuestion.dataType = q.datatype;
      currentQuestion.answer_type = q.answer_type;
      currentQuestion.difficulty = q.difficulty;
      currentQuestion.difficulty_level = q.difficulty_level || null;
      currentQuestion.time = q.time;
      currentQuestion.topic_id = q.topic_id;
      currentQuestion.topicName = q.topic ? q.topic.title : "";
      currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      switch (type) {
        case 1:
          currentQuestion.options = this.checkIfAnswered(typeId, q);
          break;
        case 2:
          if (this.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = parseInt(answer.answer);
          } else {
            currentQuestion.correct_answer = null;
          }
          break;
        case 3:
          let matrixOptions = this.separateOptions(q, 1);
          currentQuestion.options_abc = matrixOptions.options_abc;
          currentQuestion.options_pqr = matrixOptions.options_pqr;
          break;
        case 4:
          let options = this.separateOptions(q, 2);
          currentQuestion.options_abc = options.options_abc;
          currentQuestion.options_pqr = options.options_pqr;
          currentQuestion.options = options.op;
          break;
        case 6:
          if (this.data.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = answer.answer;
          } else {
            currentQuestion.correct_answer = "";
          }
          console.log("valuessssss",currentQuestion )
          let subjectiveAnswers = this.getSubjectiveAnswers(
            currentQuestion.correct_answer,
            q
          );
          currentQuestion.startValue = subjectiveAnswers.startValue;
          currentQuestion.endValue = subjectiveAnswers.endValue;
          break;
      }
      return currentQuestion;
    },
    getQuestionType(id) {
      if (
        id == this.questionTypes.ASSERTION_REASON ||
        id == this.questionTypes.MULTIPLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT_SEC2 ||
        id == this.questionTypes.COMPREHENSION_2Q_SA ||
        id == this.questionTypes.COMPREHENSION_2Q_MM ||
        id == this.questionTypes.COMPREHENSION_2Q_MA ||
        id == this.questionTypes.COMPREHENSION_3Q_SA ||
        id == this.questionTypes.COMPREHENSION_3Q_MA ||
        id == this.questionTypes.TC_2Q_SA ||
        id == this.questionTypes.TC_3Q_SA
      ) {
        return 1;
      } else if (id == this.questionTypes.INTEGER) {
        return 2;
      } else if (id == this.questionTypes.MATRIX_MATCH) {
        return 3;
      } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
        return 4;
      } else if (id == this.questionTypes.COMPREHENSION) {
        return 5;
      } else if (
        id == this.questionTypes.SUBJECTIVE ||
        id == this.questionTypes.COMPREHENSION_2Q_NU ||
        id == this.questionTypes.SUBJECTIVEINTEGER
      ) {
        return 6;
      }
    },
    async getQuestionInfo(q) {
      this.scrollableElement = document.getElementsByClassName(
        "v-dialog--active"
      )[0];
      q.previewData = true;
      if (
        !this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id) &&
        !q.isApiCalled
      ) {
        let reqData = {
          question_id: q.id,
          test_id: this.data.question.test_id,
        };
        await this.getQuesDateAndViewCountOfLastCreQues(reqData)
          .then((response) => {
            if (response) {
              q.isApiCalled = true;
              q.lastScheduledBatches = response.last_scheduled_batch_name
                ? response.last_scheduled_batch_name
                : "";
              q.lastScheduledCenters = response.last_scheduled_center_name
                ? response.last_scheduled_center_name
                : "";
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.$forceUpdate();
      this.scrollableElement.addEventListener("scroll", (event) =>
        this.handleScroll(event, q)
      );
    },
    getSubjectiveAnswers(answer, q) {
      let separatedAnswer = {
        startValue: null,
        endValue: null,
      };
      if (answer > "" && this.data.isPreview) {
        let answerArray = answer.split("##");
        if (answerArray.length == 2) {
          separatedAnswer.startValue = answerArray[0];
          separatedAnswer.endValue = answerArray[1];
        } else if (answerArray.length == 1) {
          separatedAnswer.startValue = answerArray[0];
        }
      } else if (q.user_selected_answer) {
        let answer = JSON.parse(q.user_selected_answer);
        if (
          answer.answer &&
          !answer.answer.startValue &&
          !answer.answer.endValue
        ) {
          separatedAnswer.correct_answer = parseInt(answer.answer);
        }
      }
      return separatedAnswer;
    },
    separateOptions(q, type) {
      let options = q.options;
      let op = [];
      let options_abc = [];
      let options_pqr = [];

      options.forEach((option) => {
        if (option.column == 1) {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : "";
          options_abc.push(option);
        } else if (option.column == 2) options_pqr.push(option);
        else {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : false;
          // option.correct_answer = false;
          op.push(option);
        }
      });
      if (type == 1) {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            answer.answer.map((a) => {
              let option = options_abc.find((o) => o.id == a.option_id);
              if (option) {
                option.correct_answer = a.value;
              }
            });
          }
        }
      } else {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            let option = op.find((o) => o.id == answer.answer.option_id);
            if (option) {
              option.correct_answer = true;
            }
          }
        }
      }

      return {
        op,
        options_abc,
        options_pqr,
      };
    },
    changeAddButtonStatus(question) {
      let count = 0;
      const index = this.questions.findIndex((q) => q.id === question.id);
      this.questions[index].is_bucket_question = !this.questions[index]
        .is_bucket_question;
      this.questions.map((q) => {
        if (q.is_bucket_question) {
          count = count + 1;
        }
      });
      this.onClose({ status: false, count: count, callApi: this.callApi });
    },
    onPageChange(e) {
      this.currentPage = e;
      this.getQuestionBucket();
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      // allowScroll after api gets data for 1st page
      if (isIntersecting && this.allowScroll && this.rowCount > 1) {
        this.currentPage++;
        this.getQuestionBucket();
      }
    },
    getColorForCustomTest(pallet) {
      var color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN + ' !important';
      switch (pallet.difficulty_level) {
        case 1:
          color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN + ' !important';
          break;
        case 2:
          color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE + ' !important';
          break;
        case 3:
          color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED + ' !important';
          break;

        case "default":
          color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN + ' !important';
          break;
      }
      return color;
    },
    parseTagName(tag) {
      if (tag.indexOf('MODULE_') !== 0) return tag;
      const parts = tag.split('_');

      if (parts.length < 2) return tag;
      return ['From', ...parts.slice(1), 'Module'].join(' ');
    },
    addBookmark(data) {
      let reqData = {
        user_id: this.user.id,
        question_id: data.id, 
      };
      this.addBookmarkQuestion(reqData)
        .then((response) => {
          this.$toasted.success(`Question bookmark added successfully.`, {});
          data.bookmarkQuestion = true;
        })
        .catch((err) => {
          // this.$toasted.error(`Adding Bookmarked Question failed.`, {});
        });
    },
    removeBookmarkDialog(item) {
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.alertBoxData = {
        item,
        message: "Are you sure you want to remove bookmark?",
        refId: "removeBookmark",
      };
      this.modalWidth = "350px";
      this.open = true;
      this.$forceUpdate();
    },
    removeBookmark(data) {
      let reqData = {
        user_id: this.user.id,
        question_id: data.id,
      };

      this.removeBookmarkQuestion(reqData)
        .then((response) => {
          this.$toasted.success(`Question bookmark removed successfully.`, {});
          data.bookmarkQuestion = false;
        })
        .catch((err) => {
          this.$toasted.error(`Remove Bookmarked Question failed.`, {});
        });
    },
  },
};
</script>
